import { useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { PAGE_KEY } from '@/constants/page.constants';
import type { PageKeyType, PageSlugType } from '@/constants/page.constants';

export function usePage() {
  const router = useRouterState();

  const pathname = router.location.pathname as PageKeyType;

  const [pageKey, setPageKey] = useState<PageSlugType | null>(null);

  useEffect(() => {
    setPageKey(PAGE_KEY[pathname]);
  }, [pathname]);

  return pageKey;
}
